export interface ParametroFuncao {
    label: string;
    ordem: number;
    variavel: string;
    descricao: string;
    tipo: ParametroTipo;
    obrigatorio: boolean;
    parametroPaiObrigatorio?: boolean;
    isConsulta?: boolean;
    endpointOpcoes: string;
    parametroVinculado: string;
    parametros: ParametroFuncao[];
    tamanhoMaximoExibicao: number;
    dependencias?: string[];
    obrigatorioSe?: string[];
    naoObrigatorioSe?: string[];
    autocompleteHint?: string;
}

export enum ParametroTipo {
  TEXTO = 'TEXTO',
  PERCENTUAL = 'PERCENTUAL',
  BOOLEAN = 'BOOLEAN',
  INTEIRO = 'INTEIRO',
  VALOR_FINANCEIRO = 'VALOR_FINANCEIRO',
  SELECT = 'SELECT',
  CHECKBOX = 'CHECKBOX',
  COMPOSTO = 'COMPOSTO',
  MULTI_SELECT = 'MULTI_SELECT'
}

